import React from "react";

const Spinner = () => {
  return (
    <div className="spinner">
      <div className="spinner-inner" />
    </div>
  );
};

export default Spinner;
